<!--群发短信(移动短信)-->
<template>
<div v-loading="sendLoading" element-loading-text="正在发送" style="margin-top:30px;">
    <el-form :model="addForm" label-width="100px" ref="addForm" :rules="addFormRules">
        <el-form-item label="短信内容：" prop="content">
            <el-input type="textarea" :rows="3" placeholder="请输入要发送的短信内容" v-model="addForm.content" style="margin-top:10px;">
            </el-input>
        </el-form-item>
        <el-form-item label="卡号列表：" prop="sims">
            <el-input type="textarea" :rows="20" placeholder="请粘贴要群发短信的卡号列表(每一条一行，最多100张卡)" v-model="addForm.sims" style="margin-top:10px;">
            </el-input>
        </el-form-item>
        <el-form-item style="text-align:right;">
            <el-button @click="resetSms()">重置</el-button>
            <el-button type="primary" @click="sendSms()">发送</el-button>
        </el-form-item>
    </el-form>
</div>
</template>

<script>
import {
    sendSmsGroup
} from '../../api/api'
export default {
    data() {
        return {
            addForm: {
                content: '',
                sims: ''
            },
            addFormRules: {
                content: [{
                    required: true,
                    message: '请输入要发送的短信内容',
                    trigger: 'blur'
                }],
                sims: [{
                    required: true,
                    message: '请粘贴要群发短信的卡号列表(每一条一行，最多100张卡)',
                    trigger: 'blur'
                }]
            },
            sendLoading: false
        }
    },
    methods: {
        resetSms() {
            this.$refs['addForm'].resetFields();
        },
        sendSms() {

            this.$refs.addForm.validate((valid) => {
                if (valid) {

                    this.$confirm("确定要群发短信吗？", '确认提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let para = Object.assign({}, this.addForm);
                        para.server = '51saibo';
                        this.sendLoading = true;
                        sendSmsGroup(para).then((res) => {
                            this.sendLoading = false;
                            if (res.code == 0) {
                                this.resetSms();
                            } else {
                                this.$message({
                                    dangerouslyUseHTMLString: true,
                                    message: res.msg,
                                    type: 'error'
                                });
                            }
                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消操作'
                        });
                    });

                }
            });

        }
    }

}
</script>  

<style>

</style>



// WEBPACK FOOTER //
// groupsms.vue?5aa53d62